// Fuel Savings
export const SAVE_FUEL_SAVINGS = 'SAVE_FUEL_SAVINGS';
export const CALCULATE_FUEL_SAVINGS = 'CALCULATE_FUEL_SAVINGS';

// Loading
export const LOADING = 'LOADING';
export const LOADING_COMPLETE = 'LOADING_COMPLETE';

// Loading Indicator
export const LOADING_INDICATOR_START = 'LOADING_INDICATOR_START';
export const LOADING_INDICATOR_SET_PERCENT = 'LOADING_INDICATOR_SET_PERCENT';

// Customer
export const LOAD_CUSTOMER_SUCCESS = 'LOAD_CUSTOMER_SUCCESS';
export const UPDATE_CUSTOMER_SUCCESS = 'UPDATE_CUSTOMER_SUCCESS';

// States List
export const LOAD_STATES_SUCCESS = 'LOAD_STATES_SUCCESS';



// WEBPACK FOOTER //
// ./src/actions/actionTypes.js